const whatisapcn = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'What is a PCN?',
            },
            {
                "type": "tabs",
                "size": "8",
                "style": "",
                "class": "pr-4",
                "children": [
                    {
                        "title": "What is a PCN?",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "onlineServicesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "min-height: calc(100vh - 144px)",
                                    "class": "pl-3 pt-3",
                                    "form": {
                                        // "page_title": {
                                        //     "type": 'text',
                                        //     "label": 'Title',
                                        //     "placeholder": 'Enter Title',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 250,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "hr1": {
                                        //     "type": 'hr',
                                        //     "size": "12",
                                        // },
                                        "title": {
                                            "type": 'text',
                                            "label": 'Title',
                                            "placeholder": 'Enter Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        // "logo": {
                                        //     "type": 'imgSelect',
                                        //     "label": 'Logo',
                                        //     "placeholder": 'Select Logo',
                                        //     "load_url": '',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        "hr2": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "text": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": true,
                                            "info": false,
                                            "character_count": 1000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr3": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                        "video": {
                                            "type": 'toggle',
                                            "label": 'Video',
                                            "placeholder": 'Video',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "video_url": {
                                            "type": 'text',
                                            "label": 'Video URL',
                                            "hideLabel": true,
                                            "placeholder": 'Enter Video URL',
                                            "displayOn": "video",
                                            "displayOnValue": 'true',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "hr4": {
                                            "type": 'hr',
                                            "size": "12",
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                ]
            },

        ]
    }
]

export { whatisapcn };